import "@fontsource/source-serif-4/latin-400.css";
import "@fontsource/source-serif-4/latin-600.css";
import "@fontsource/source-serif-4/latin-400-italic.css";
import "./styles/tokens.css";
import "./styles/base.css";
import "./styles/components.css";

import { createPinia } from "pinia";
import { createApp } from "vue";

import App from "./App.vue";
import router from "./router";

const app = createApp(App);
app.use(createPinia());
app.use(router);
// Iconos Phosphor: el diseño usa el peso duotone en toda la app.
app.provide("weight", "duotone");
app.mount("#app");
